import { Component, HostBinding, OnInit } from '@angular/core';
import { EventosCompartidosService } from '@global-service/eventosCompartidos/eventosCompartidos.service';
import { NavegacionService } from '@global-service/navegacion/navegacion.service';
import { of } from 'rxjs';
import { AuthenticationService } from '@app/services/auth/authentication.service';
import { StatusService } from '@app/services/status';
import { RutasGlobales } from '@app/routes/routes';

@Component({ standalone: false, selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
})
export class SidebarComponent implements OnInit {
  @HostBinding('class.sidebar-expanded')
  get sidebarExpanded(): boolean {
    return this.isActive;
  }

  public isActive: boolean;
  public enPaginaClientesBackOffice = of(false);

  get rutaActual() {
    return this.navegacionService.getKeyRuta();
  }
  constructor(
    public readonly authService: AuthenticationService,
    private readonly statusService: StatusService,
    private readonly navegacionService: NavegacionService,
    private readonly eventosCompartidos: EventosCompartidosService
  ) {
    this.isActive = true;
  }

  ngOnInit() {
    const ls_status = localStorage.getItem('sidebar_active');
    this.enPaginaClientesBackOffice = this.eventosCompartidos.$enPaginaClientesBackOffice();
    if (ls_status) {
      this.isActive = ls_status === 'true';
    }
  }

  logout() {
    this.authService.logout();
  }

  toggle() {
    this.isActive = !this.isActive;
    localStorage.setItem('sidebar_active', this.isActive + '');
  }

  dblClickNodeHandler(node: any) {
    this.statusService.cambiarEstadoTienda(node);
  }

  onGoToAdminPage(page: RutasGlobales) {
    this.navegacionService.navegar(page);
  }
}
